import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  TextField,
  Typography
} from '@mui/material';
import React, { FC, memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import DocManagementService from '../documentUpload/service/DocManagementService';

const ReviewWorkflowDialog: FC<any> = ({
  openReviewDialog,
  setOpenReviewDialog,
  props,
  setDataGridComponent,
  buttonText,
  taskId,
  setDisableButton,
  taskTitle
}: any) => {
  const [loading, setLoading] = useState(false);
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const fileMasterId = documentDetail.data[0].fmId;
  const tmfDocId = documentDetail.data[0].tmf_document_id;
  const docService = new DocManagementService();
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const [reason, setReason] = useState('');
  const [isProcessing, setProcessing] = React.useState(false);
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const dispatch = useDispatch();
  let TmfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (TmfLevel === '--') {
    TmfLevel = 'Study';
  }

  const handleCloseRejectDialog = () => {
    setOpenReviewDialog(false);
  };
  const handleConfirmClick = async () => {
    setProcessing(true);
    const CompleteReviewData = {
      action_name: 'Complete Review',
      is_resolved: true,
      updated_by: userName
    };
    const RejectReviewData = {
      user_name: '',
      user_email_id: 'user@example.com',
      action_name: 'Reject',
      reject_reason: reason,
      updated_by: ''
    };
    const params = {
      module_section_related: 'DocumentReview',
      parent_entity_related: 'ReviewWorkflow'
    };
    if (buttonText === 'Reject') {
      const response = await docService.RejectReview(
        documentDetail.data[0].task_Id ? documentDetail.data[0].task_Id : taskId,
        RejectReviewData,
        params,
        selectedStudy,
        selectedCountry,
        selectedSite,
        TmfLevel
      );
      response.data
        ? store.dispatch(setSnackbarMessage('Review Rejected.', 'success'))
        : store.dispatch(setSnackbarMessage('Error in rejecting review.', 'error'));
      response.data ? setDisableButton(true) : setDisableButton(false);
    } else {
      const result = await docService.completeReview(
        params,
        documentDetail.data[0].task_Id ? documentDetail.data[0].task_Id : taskId,
        CompleteReviewData,
        selectedStudy,
        selectedCountry,
        selectedSite,
        documentDetail.data[0].tmf_doc_level
      );
      result.data
        ? store.dispatch(setSnackbarMessage('Review completed successfully.', 'success'))
        : store.dispatch(setSnackbarMessage('Error in completing review.', 'error'));
      result.data ? setDisableButton(true) : setDisableButton(false);
    }
    setProcessing(false);
    setOpenReviewDialog(false);
  };

  const handleReason = (e: any) => {
    setReason(e.target.value);
  };

  return (
    <React.Fragment>
      <PopupComponent
        open={openReviewDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{buttonText === 'Reject' ? 'Reject' : 'Complete Review'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {buttonText === 'Reject'
              ? `Are you sure you would like to reject this document?`
              : `Are you sure your review is complete?`}
          </DialogContentText>
          <br></br>
          <Typography style={{ fontWeight: 'bold' }}>
            {`'${documentDetail.data[0]?.tasks_title ? documentDetail.data[0]?.tasks_title?.trim() : taskTitle}'`}
            <span style={{ fontWeight: 200 }}>
              {''}
              {buttonText === 'Reject'
                ? ' task will be send back to the uploader.'
                : ' task will be marked as completed.'}
            </span>
          </Typography>
          {buttonText === 'Reject' ? (
            <Grid md={12} sx={{ pt: 0.5 }}>
              <FormControl variant="standard" fullWidth>
                <TextField
                  id="standard-basic"
                  label="Reason"
                  variant="standard"
                  defaultValue=""
                  value={reason}
                  inputProps={{
                    maxLength: 300
                  }}
                  onChange={e => handleReason(e)}
                />
              </FormControl>
            </Grid>
          ) : (
            ''
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseRejectDialog} className="grey-btn" disabled={isProcessing}>
            CLOSE
          </Button>
          <Button onClick={() => handleConfirmClick()} autoFocus disabled={isProcessing}>
            CONFIRM
          </Button>
        </DialogActions>
      </PopupComponent>
    </React.Fragment>
  );
};

export default memo(ReviewWorkflowDialog);
